module.exports = __webpack_public_path__ + "img/dynamoDB-Capacity-Calculator.0181cf5f.jpg";